<template>
    <details class="card card--collapsible" open>
        <summary class="card__title card__title--bg-secondary">
            <h5>{{ modelValue.title }}</h5>
        </summary>
        <div class="card__content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="table-responsive">
                        <vue-good-table :columns="[
                            {
                                label : 'Conciliado',
                                field : 'conciliado',
                                filterable : false,
                            },
                            {
                                label: '# Documento',
                                field: 'numero_documento',
                                filterable: true
                            },
                            {
                                label: 'Fecha de emisión',
                                field: 'fecha_emision',
                                filterable: true
                            },                        
                            {
                                label : 'Cliente',
                                field : 'nombre_cliente',
                                filterable : true,
                            },
                            {
                                label : 'Subtotal',
                                field : 'subtotal',
                                filterable : false,
                            }, 
                            {
                                label : 'Margen',
                                field : 'margen',
                                filterable : false,
                            }, 
                            {
                                label : 'IVA',
                                field : 'valor_iva',
                                filterable : false,
                            },
                            {
                                label : 'Total',
                                field : 'valor_total',
                                filterable : false,
                            },
                            {
                                label : '',
                                field : 'acciones'
                            }
                        ]"
                        :pagination-options="{
                                enabled: false
                            }"
                        :rows="modelValue.comprobantes"
                        :search-options="{
                            enabled: true,
                            placeholder: 'Buscar...'
                        }"
                        styleClass="vgt-table">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'numero_documento'">
                                    {{ props.row.codigo_establecimiento }}-{{ props.row.codigo_emisor }}-{{ props.row.numero_secuencial }}
                                </span>
                                <span v-else-if="props.column.field === 'subtotal' || props.column.field === 'valor_iva' || props.column.field === 'valor_total'">
                                    {{ moneyFormat(props.formattedRow[props.column.field]) }}
                                </span>
                                <span v-else-if="props.column.field === 'margen'">
                                    <input-field @blur="blurMargen(props.row.originalIndex)" :readonly="!permiteEditarComision" placeholder="$ #,###.##" vMoney :format="moneyNegative" v-model="modelValue.comprobantes[props.row.originalIndex].margen" :id="'margenes' + modelValue.title + props.row.originalIndex"></input-field>
                                </span>
                                <span v-else-if="props.column.field === 'conciliado'">
                                    <label :for="'conciliado' + props.index + modelValue.title">
                                        <input v-model="modelValue.comprobantes[props.row.originalIndex].conciliado" type="checkbox" :id="'conciliado' + props.index + modelValue.title"><span></span>
                                    </label>
                                </span>
                                <span v-else-if="props.column.field === 'acciones'">
                                    <button type="button" @click="cambiarVendedor(props.row)" class="btn-primary btn--text"><i class="fa fa-edit"></i></button>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-xs-12">
                    <div class="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Observación</th>
                                    <th>Margen total</th>
                                    <th>Saldo anterior</th>
                                    <th>Saldo</th>
                                    <th>Comisión</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <button @click="marcarTodos" class="btn-success btn--text">
                                            <i class="fa fa-check"></i><span>Marcar todos</span>
                                        </button>
                                        <button @click="desmarcarTodos" class="btn-danger btn--text">
                                            <i class="fa fa-times"></i><span>Desmarcar todos</span>
                                        </button>
                                    </td>
                                    <td>
                                        <textarea-field v-model="modelValue.observacion" placeholder="Escriba una observación..." :id="'observacion' + $vnode.key">
                                            <span
                                            v-if="errores.hasOwnProperty('vendedores.' + index + '.observacion')"
                                            class="helper-text text-danger"
                                            slot="helper"
                                            >
                                                <strong>{{ errores['vendedores.' + index + '.observacion'][0] }}</strong>
                                            </span>
                                        </textarea-field>
                                    </td>
                                    <td>
                                        {{ moneyFormat(margen) }}
                                    </td>
                                    <td>
                                        {{ moneyFormat(saldo_anterior) }}
                                    </td>
                                    <td>
                                        {{ moneyFormat(modelValue.saldo) }}
                                    </td>
                                    <td>
                                        {{ moneyFormat(comision) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <modal :clickToClose="false" name="cambiarVendedor" width="50%" height="auto" scrollable>
                    <cambiar-vendedor @vendedorCambiado="$emit('vendedorCambiado')" :vendedorId="currentVendedorId" @cerrar="$modal.hide('cambiarVendedor')" :comprobanteId="currentComprobanteId" :vendedores="vendedores" ></cambiar-vendedor>
                </modal>
            </div>
        </div>
    </details>
</template>

<script>
export default {
    props : {
        permiteEditarComision : {
            type : Boolean,
            required : false,
            default : false
        },
        index : {
            type : Number,
            required : true
        },
        errores : {
            type : Object,
            required : false,
            default : function () {
                return {};
            }
        },
        value : {
            type : Object,
            required : true
        },
        porcentaje_comision : {
            required : false,
            default : 0
        },
        comision_base : {
            required : false,
            default : 0
        },
        saldo_anterior : {
            required : false,
            default : 0
        },
        vendedores :  {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        }
    },
    data : function () {
        return {
            moneyNegative : moneyNegative,
            decimalFormat : decimalFormat,
            moneyFormat : moneyFormat,
            money : money,
            modelValue : this.value,
            currentComprobanteId : '',
            currentVendedorId : ''
        };
    },
    computed : {
        margen : function () {
            let margen = 0;
            for (let i = 0; i < this.modelValue.comprobantes.length; i++)
                if (this.modelValue.comprobantes[i].conciliado)
                    margen += parseFloat(this.modelValue.comprobantes[i].margen);
            this.modelValue.margen = margen;
            return margen;
        },
        comision : function () {
            let comision = 0;
            if (this.margen > 0) {
                let diferencia = round((this.margen - parseFloat(this.comision_base) - this.saldo_anterior));
                if (diferencia < 0) 
                {
                    this.modelValue.saldo = diferencia * -1;
                    comision = 0;
                }
                else 
                {
                    comision = round(diferencia * (this.porcentaje_comision / 100));
                    this.modelValue.saldo = 0;
                }
            }
            else 
                this.modelValue.saldo = 0;
            this.modelValue.comision = comision;
            return comision;
        }
    },
    methods : {
        blurMargen : function (index) {
            if (this.modelValue.comprobantes[index].margen == '' || this.modelValue.comprobantes[index].margen == null)
                this.modelValue.comprobantes[index].margen = 0;
        },
        cambiarVendedor : function (comprobante) {
            this.currentComprobanteId = comprobante.id_comprobante;
            this.currentVendedorId = comprobante.vendedor_id;
            this.$modal.show('cambiarVendedor');
        },
        marcarTodos : function () {
            for (let i = 0; i < this.modelValue.comprobantes.length; i++)
                this.modelValue.comprobantes[i].conciliado = true;
        },
        desmarcarTodos : function () {
            for (let i = 0; i < this.modelValue.comprobantes.length; i++)
                this.modelValue.comprobantes[i].conciliado = false;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/cierre-comisiones/ItemCierreComisiones.vue